(function ($) {
    $(document).ready(function () {


        //TODO make this file with porototypes, avoid ES6 and and make this file work only on Avocado theme

        $('.js-navbar-drawer-toggle-item').on('click', function (e) {
            if (!$(e.currentTarget).hasClass('active')) {
                $('.js-navbar-drawer-toggle-item.active').removeClass('active');
            }
            $(e.currentTarget).toggleClass('active');
        });

        $('.js-lm-navbar-burger, .js-navbar-drawer-overlay').on('click', function (e) {
            $('.js-navbar-drawer').toggleClass('active');
            $('.js-navbar-drawer-overlay').toggleClass('active');
        });

        function lm_swiper() {
            var swiper = new Swiper('.js-swiper-testimonials', {
                spaceBetween: 0,
                centeredSlides: true,
                slidesPerView: 'auto',
                initialSlide: 1,
                loop: true,
            });
        }

        lm_swiper();


        $('.js-nice-select').niceSelect();
    });
})(jQuery);